'use client';

import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/Select';
import { Stratege, strategies } from '../Workspace/StrategyLab/strategy-config';
import { useTranslation } from '@/lib/i18n';

interface StrategyTypesProps {
  onChange: (type: Stratege) => void;
}
export default function StrategyTypes(props: StrategyTypesProps) {
  const { onChange } = props;
  const [type, setType] = useState<Stratege>();

  const { t } = useTranslation();

  const handleChange = (type: Stratege) => {
    onChange(type);
    setType(type);
  };

  return (
    <Select onValueChange={handleChange} value={type}>
      <SelectTrigger className="w-[160px] focus:ring-0 focus:ring-ring focus:ring-offset-0 rounded-full border border-[#2a2a2a] px-3 h-[32px] cursor-pointer flex items-center justify-between">
        <SelectValue placeholder="Skills" />
      </SelectTrigger>
      <SelectContent className="bg-bg-main">
        {strategies.map((item) => (
          <SelectItem key={item.value} value={item.value} className="bg-bg-main py-1">
            <div className="flex items-center gap-2">{t(item.label)}</div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
